import styled from "@emotion/styled"
import { PHeading } from "@porsche-design-system/components-react"
import { spacingStaticLg } from "@porsche-design-system/components-react/emotion"
import { FormattedMessage } from "react-intl"
import { Skeleton } from "src/components"
import { listingScoreHintsMessages } from "./listingScoreHints.messages"

export const ListingScoreHintsSkeleton = () => (
	<>
		<PHeading size="lg" tag="h2">
			<FormattedMessage {...listingScoreHintsMessages.headline} />
		</PHeading>
		<ContentSkeleton />
	</>
)

const ContentSkeleton = styled(Skeleton)`
	margin: ${spacingStaticLg} 0 0;
	height: 12vh;
`
